
import Breadcrumb from '@/components/Breadcrumb'
import WxFollowQr from '@/components/WxFollowQr'
import TitleBox from '@/components/CSS/TitleBox'
import empowerDialog from '@/components/empowerDialog'
import ReleaseRulePhone from '@/components/ReleaseRulePhone'
import Upload from '@/components/Upload/releaseUpload'
import { mapGetters } from 'vuex'
import { debounce } from '@/utils/validate'
import { UPLOAD_COMMON_TYPE } from '@/enum/uploadType'
import { getTimeDifference } from '@/utils/index'
import GameHeader from '@/components/release/gameHeader'
import QuestionDialog from '@/components/release/editGoodsInfo/QuestionDialog'
import Single from '@/components/release/form/single'
import CheckBox from '@/components/release/form/checkbox'
import FormInput from '@/components/release/form/input'
import DynamicFormField from '@/components/release/form/DynamicFormField'
import PackageDialog from '@/components/release/PackageDialog'
import PackageTable from '@/components/release/PackageTable'
import PZBtton from '@/components/PZButton'

export default {
    components: {
        Breadcrumb,
        WxFollowQr,
        empowerDialog,
        TitleBox,
        Upload,
        GameHeader,
        QuestionDialog,
        Single,
        CheckBox,
        FormInput,
        DynamicFormField,
        PackageDialog,
        PackageTable,
        PZBtton
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo',
            releaseDataObj: 'game/releaseDataObj',
            exposureNum: 'game/exposureNum',
            config: 'config',
        }),
        showLoading() {
            if (this.goodsKeyByBase.length) {
                return false
            }
            return true
        },
        filterGoodsKeyBySku() {
            return this.goodsKeyBySku.filter(item => item.mappingField !== 'skuTitle')
        }
    },
    data() {
        return {
            submitLoading: false,
            agreementChecked: false, // 协议同意状态
            rules: {},
            ruleForm: {},
            goodsKeyByBase: [], //基本信息
            goodsKeyBySku: [], //SKU信息
            articleDetail: {}, //购买须知
            ruleUserPhone: false, // 验证手机号码
            dataTime: ['', ''],
            UPLOAD_COMMON_TYPE,
            startTime: null,
            releaseData: {},
            skuList: [], // 多套餐列表
            currentEditIndex: -1, // 当前编辑的套餐索引
            selectPackageIndex: 0, // 表格选中的行
            feeDataList: [], // 服务费列表
            skuForm: {}, // 套餐表单
        }
    },
    async created() {
        // 编辑专用;
        // this.ruleForm.goodsNo = this.$route.query.goodsNo || null
        this.releaseData = this.releaseDataObj[this.releaseDataObj.currentId] || {}
        console.log("this.releaseDataObj", this.releaseDataObj, this.releaseDataObj.currentId)
        // 获取服务费
        this.getFeeData()
        // 添加
        this.initConfig()
        // 显示用户保障信息
        this.getUserLinkMessageHandler()
    },
    mounted() {
        this.startTime = new Date().getTime()
        this.$store.dispatch('game/ExposureNum')
    },
    methods: {
        onEmpowerDialogClose() {
            this.submitLoading = false
        },
        // 显示用户保障信息
        getUserLinkMessageHandler() {
            this.$api.getUserLinkMessage().then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                const data = res.data
                this.ruleForm.linkPhone = data.linkPhone
                this.ruleForm.linkQq = data.linkQq
                this.ruleForm.linkWx = data.linkWx
                this.dataTime[0] = data.easyTradeStartTime
                this.dataTime[1] = data.easyTradeEndTime
            })
        },
        /**
         * 重新选择，如果是编辑就带goodsNo
         */
        reselectBtn() {
            let p = {
                pcIconUrl: this.releaseData.pcIconUrl,
                gameId: this.releaseData.gameId,
                goodsCatalogueId: this.releaseData.goodsCatalogueId,
                gameName: this.releaseData.gameName
            }
            this.$store.commit('game/SET_RELEASE_DATA', p)
            this.$router.go(-1)
        },
        formatResult(gameConfig, data) {
            // 准备动态字段
            const dynamicFields = []
            const formData = {}

            // 一次遍历处理所有配置项
            for (const item of gameConfig) {
                // 使用表单项中已计算好的规则结果
                const ruleResult = item.ruleResult
                // 只处理显示的字段
                if (!ruleResult || ruleResult.display) {
                    const fieldValue = data[item.mappingField] || null
                    // 处理动态属性
                    if (item.dynamic) {
                        dynamicFields.push({
                            fieldType: item.fieldType,
                            fieldValue: fieldValue || null,
                            mappingField: item.mappingField
                        })
                    }
                    // 处理普通属性
                    else if (fieldValue !== undefined) {
                        formData[item.mappingField] = fieldValue
                    }
                }
            }

            // 如果有动态字段，添加到结果中
            formData.dynamicFields = dynamicFields
            console.log('🚀 formData', formData)
            return formData
        },
        releaseConfirm: debounce(function (p) {
            this.saveData(p)
        }),
        saveData(p) {
            console.log(p, '保存的数据');
            this.$api.saveGeneralGoods(p).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.$api.setSellerGuideGoodsAPI({ del: true })
                this.saveGoodsResetFields(res.data.goodsNo)
                console.log(res.data)
            })
        },
        async getFeeData() {
            // 获取服务费
            let data = {
                action: {
                    gameId: this.releaseData.gameId,
                    goodsCatalogueId: this.releaseData.goodsCatalogueId,
                    goodsSubCatalogueId: this.releaseData.goodsSubCatalogueId || null,
                    goodsNo: this.releaseData.goodsNo || null
                }
            }
            const res = await this.$api.getFeeNew(data)
            console.log(res, 'res')
            if (res.success) {
                this.feeDataList = res.data
            }
        },
        releaseRulePhoneConfirm(p) {
            this.releaseConfirm(p)
        },
        async toggleAgreement() {
            this.agreementChecked = !this.agreementChecked
        },
        async viewAgreement() {
            // 检查协议是否同意
            await this.$refs?.questionDialogRef.open()
            this.agreementChecked = true
        },
        async agreementCheckedFn() {
            if (!this.agreementChecked) {
                await this.$refs?.questionDialogRef.open()
                this.agreementChecked = true
            }
        },
        async check() {
            const res = await this.$api.generalGoodsCheck({
                publishFlowId: this.releaseData.publishFlowId
            })
            if (!res.success) {
                this.$message.error(res.info)
                return false
            }
            const { isBlack, isPublishAuth } = res.data
            if (isBlack) {
                this.$message.error('该游戏账号已被拉黑，无法交易')
                return false
            }
            if (!isPublishAuth) {
                this.$message.error('您没有发布商品权限，请联系客服处理')
                return false
            }
            return true
        },
        // 提交
        onSubmit() {
            this.$refs.ruleForm.validate(async valid => {
                if (valid) {
                    console.log(valid)

                    const form = this.formatResult(this.goodsKeyByBase, this.ruleForm)
                    let action = { ...form, gameId: this.releaseData.gameId, goodsCatalogueId: this.releaseData.goodsCatalogueId, publishFlowId: this.releaseData.publishFlowId }
                    console.log(action)
                    if (this.goodsKeyBySku?.length) {
                        if (this.skuList.length) {
                            action.skuList = this.skuList?.map(item => ({...this.formatResult(this.goodsKeyBySku, item), master: item.master, enable: item.enable})) || []
                        } else {
                            action.skuList = [{ ...this.formatResult(this.goodsKeyBySku, this.skuForm), enable: true, master: true }] || []
                            const skuValid = await this.$refs.skuForm?.validate()
                            if (!skuValid) {
                                // 套餐表单验证失败时，定位到错误
                                this.scrollToFirstError()
                                return
                            }
                        }
                    }
                    await this.agreementCheckedFn()
                    const isCheck = await this.check()
                    if (!isCheck) {
                        return
                    }
                    this.releaseConfirm(action)
                    return
                }
                // 使用Element UI提供的错误字段信息直接定位
                this.scrollToFirstError()
                this.submitLoading = false
            })
        },
        // 自动定位到第一个错误字段
        scrollToFirstError() {
            setTimeout(() => {
                const errorElement = document.querySelector('.is-error')
                // 滚动到错误位置并高亮
                if (errorElement) {
                    errorElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    })
                }
            }, 100)
        },
        // 发布成功清空表单跳转至结果页
        saveGoodsResetFields(goodsNo) {
            // 重置表单数据
            this.$refs.ruleForm.resetFields()
            this.$router.replace(`/success?goodsNo=${goodsNo}&gameId=${this.releaseData.gameId}&goodsCatalogueId=${this.releaseData.goodsCatalogueId}`)
            // 清空发布数据、发布面包屑
            setTimeout(() => {
                this.$store.commit('game/CLEAR_RELEASE_DATA', this.releaseData.gameId)
                this.$store.commit('game/SET_RELEASE_BREADCRUMB', {})
            }, 300)
        },
        initConfig() {
            return new Promise(() => {
                let p = {
                    gameId: this.releaseData.gameId,
                    goodsCatalogueId: this.releaseData.goodsCatalogueId,
                    publishFlowId: this.releaseData.publishFlowId
                }
                console.log("p", p)
                this.$api.getPublishGeneralFlowAttrs(p).then(res => {
                    if (!res.success) {
                        this.$message.error(res.info)
                        return
                    }
                    const priceFieldsObj = {}
                    const filterConfig = res.data.filter(item => {
                        // 单独把单价和单位剔除出来 后续绑定在价格组件上面
                        if (['unitNumPrice', 'unitPriceNum', 'unit'].includes(item.mappingField)) {
                            priceFieldsObj[item.mappingField] = item.valueDefault
                            return false
                        }
                        return true
                    })
                    filterConfig.forEach(item => {
                        if (['price', 'skuPrice'].includes(item.mappingField)) {
                            item.priceFields = priceFieldsObj
                        }
                        switch (item.bizType) {
                            case 'SKU':
                                if (item.mappingField === 'skuTitle') {
                                    this.skuForm.skuTitle = item.valueDefault || '默认套餐'
                                }
                                this.goodsKeyBySku.push(item)
                                break
                            default:
                                this.goodsKeyByBase.push(item)
                                break
                        }
                    })
                })
            })
        },
        // 添加第一个套餐
        addSku() {
            const currentIndex = this.skuList?.length || 0
            this.$refs.packageDialogRef?.open(currentIndex, this.goodsKeyBySku)
        },

        // 处理表格选择变化
        handleSelectionChange(index) {
            this.selectPackageIndex = index;
        },
        // 设为主套餐
        setMainSku() {
            const targetSet = this.skuList[this.selectPackageIndex]

            // 检查该套餐是否已启用
            if (!targetSet.enable) {
                this.$message.warning('请先启用套餐后再设置为主套餐')
                return
            }

            // 如果点击的是已经是主套餐的套餐，不做任何操作
            if (targetSet.master) {
                this.$message.warning('该套餐已经是主套餐')
                return
            }
            // 清除之前的主套餐标记
            this.skuList.forEach((item, ii) => {
                item.master = ii === this.selectPackageIndex;
            });
        },
        // 编辑套餐
        editSku(index) {
            const skuDialogData = { ...this.skuList[index] }
            this.$refs.packageDialogRef?.open(index, this.goodsKeyBySku, skuDialogData)
        },

        // 删除套餐
        onRemove(index) {
            const removedItem = this.skuList[index]
            const isMainSku = removedItem.master
            this.skuList.splice(index, 1);
            if (isMainSku && this.skuList.length > 0) {
                // 将第一个套餐设为主套餐
                this.skuList[0].master = true
                // 如果第一个套餐未启用，则启用它
                if (!this.skuList[0].enable) {
                    this.skuList[0].enable = true
                }
                // 把选中态移动到第一个
                if (this.selectPackageIndex === index) {
                    this.selectPackageIndex = 0
                }
            }
        },
        // 处理上架状态切换
        handleSwitchChange(index) {
            const currentSet = this.skuList[index]

            // 如果当前是启用状态，要关闭时检查是否是主套餐
            if (currentSet.enable && currentSet.master) {
                this.$message.warning('主套餐不支持关闭启用状态')
                return
            }

            // 直接修改状态（Vue会自动检测到变化）
            currentSet.enable = !currentSet.enable
        },
        // 处理套餐确认
        handlePackageConfirm(data, action, handleIndex) {
            console.log('data====', data, action);
            if (action === 'editSku') {
                this.$set(this.skuList, handleIndex, { ...this.skuList[handleIndex], ...data })
                return
            }
            // 如果是第一个套餐，默认设为主套餐
            const skuData = { ...data, enable: true }
            if (this.skuList.length === 0) {
                this.skuList.push({ ...skuData, master: true });
            } else {
                this.skuList.push({ ...skuData, master: false });
            }
            this.$message.success(`套餐【${data.skuTitle}】添加成功`);
        },
    }
}
